document.addEventListener("DOMContentLoaded", function (event) {
	const menuButton = document.getElementById("menu-button");
	const menuItems = document.getElementById("menu-items");
	let isMobile = window.innerWidth < 768;

	if (menuButton && menuItems) {
		menuButton.addEventListener("click", function () {
			const isExpanded = menuButton.getAttribute("aria-expanded") === "true";
			menuButton.setAttribute("aria-expanded", !isExpanded);
			menuItems.classList.toggle("hidden");
		});

		// Close the dropdown menu if the user clicks outside of it
		document.addEventListener("click", function (event) {
			if (
				!menuButton.contains(event.target) &&
				!menuItems.contains(event.target)
			) {
				menuButton.setAttribute("aria-expanded", "false");
				menuItems.classList.add("hidden");
			}
		});
	} else {
		console.error("Menu button or menu items not found.");
	}

	/**
	 * Toggles the visibility of the fullscreen menu and updates the menu icon.
	 *
	 * @return {void}
	 */
	const burgerMenuButtons = document.getElementsByClassName("burgerMenuBtn");
	for (let i = 0; i < burgerMenuButtons.length; i++) {
		burgerMenuButtons[i].addEventListener("click", function () {
			document.getElementById("fullscreen-menu").classList.toggle("hidden");
			document.getElementById("burgerMenuSvg").classList.toggle("hidden");
			document.getElementById("burgerMenuCloseSvg").classList.toggle("hidden");
		});
	}

	// Toggle submenu visibility and opacity
	const toggleSubmenuVisibility = (submenuContainer) => {
		isMobile = window.innerWidth < 768;
		if (isMobile) {
			submenuContainer.classList.toggle("hidden");
			submenuContainer.classList.toggle("isMobileActive");
		} else {
			submenuContainer.classList.toggle("md:invisible");
			submenuContainer.classList.toggle("md:opacity-0");
			submenuContainer.classList.toggle("md:visible");
			submenuContainer.classList.toggle("md:opacity-100");

			// Add z-index when visible to ensure it appears above other elements
			if (submenuContainer.classList.contains("md:visible")) {
				submenuContainer.style.zIndex = "50";
			} else {
				submenuContainer.style.zIndex = "";
			}
		}
	};

	// Determine rotation classes based on template
	const getRotationClasses = () => {
		const bodyClassList = document.body.classList;
		return bodyClassList.contains("hheo-template-1")
			? { add: "rotate-180", remove: "-rotate-90" }
			: bodyClassList.contains("hheo-template-2")
			? { add: "-rotate-90", remove: "rotate-180" }
			: bodyClassList.contains("hheo-template-3")
			? { add: "rotate-180", remove: "-rotate-90" }
			: { add: "rotate-180", remove: "-rotate-90" };
	};

	// Reset other submenus
	const resetOtherSubmenus = (currentSubmenuContainer) => {
		const allSubmenuContainers =
			document.querySelectorAll(".submenu-container");

		allSubmenuContainers.forEach((container) => {
			if (container !== currentSubmenuContainer) {
				// Close submenu
				if (isMobile) {
					container.classList.add("hidden");
					container.classList.remove("isMobileActive");
				} else {
					container.classList.add("md:invisible", "md:opacity-0");
					container.classList.remove("md:visible", "md:opacity-100");
				}

				// Reset arrow icon
				const arrowIcon = container.previousElementSibling.querySelector(
					".submenu-arrow-icon.fa-chevron-down",
				);
				if (arrowIcon) {
					// Remove rotation classes
					console.log(`arrowIcon: ${arrowIcon}`);
					arrowIcon.classList.remove("rotate-180", "-rotate-90");
				}
			}
		});
	};

	// Handle submenu toggle
	const handleSubmenuToggle = (menuItem, arrowIcon) => {
		const submenuContainer = menuItem.nextElementSibling;

		if (
			!submenuContainer ||
			!submenuContainer.classList.contains("submenu-container")
		) {
			return;
		}

		// Reset other submenus first
		resetOtherSubmenus(submenuContainer);

		// Check if current submenu is open
		let isOpen = false;
		if (isMobile) {
			isOpen = submenuContainer.classList.contains("isMobileActive");
		} else {
			isOpen =
				submenuContainer.classList.contains("md:visible") &&
				!submenuContainer.classList.contains("md:invisible");
		}

		// Get rotation classes
		const { add: rotationAddClass, remove: rotationRemoveClass } =
			getRotationClasses();

		// Toggle submenu and arrow
		if (!isOpen) {
			// Open submenu
			arrowIcon.classList.add(rotationAddClass);
			arrowIcon.classList.remove(rotationRemoveClass);
			toggleSubmenuVisibility(submenuContainer);
		} else {
			// Close submenu
			arrowIcon.classList.remove(rotationAddClass);
			toggleSubmenuVisibility(submenuContainer);
		}
	};

	// Add event listeners to menu items with submenu
	const itemsWithSubmenu = document.getElementsByClassName("item-has-submenu");
	for (let item of itemsWithSubmenu) {
		item.addEventListener("click", function (e) {
			e.preventDefault();

			// Find arrow icon
			const arrowIcon = e.target
				.closest(".item-has-submenu")
				.querySelector(".submenu-arrow-icon");

			if (arrowIcon) {
				handleSubmenuToggle(this, arrowIcon);
			}
		});
	}

	// Add event listener to close submenus when clicking outside
	window.addEventListener("click", function (e) {
		// Check if the click is outside menu items with submenu
		const isClickInsideSubmenu = e.target.closest(
			".item-has-submenu, .submenu-container",
		);

		if (!isClickInsideSubmenu) {
			const allSubmenuContainers =
				document.querySelectorAll(".submenu-container");

			allSubmenuContainers.forEach((submenuContainer) => {
				// Close submenu
				if (isMobile) {
					submenuContainer.classList.add("hidden");
					submenuContainer.classList.remove("isMobileActive");
				} else {
					submenuContainer.classList.add("md:invisible", "md:opacity-0");
					submenuContainer.classList.remove("md:visible", "md:opacity-100");
				}

				// Reset arrow icon
				const arrowIcon = submenuContainer.previousElementSibling.querySelector(
					".submenu-arrow-icon",
				);

				if (arrowIcon) {
					// Remove rotation classes
					arrowIcon.classList.remove("rotate-180", "-rotate-90");
				}
			});
		}
	});

	function toggleAnswer(id, btn) {
		var answer = document.getElementById(id);
		var icon = btn.querySelector("i");
		var parent = btn.closest(".accordion-item");

		if (answer.classList.contains("hidden")) {
			answer.classList.remove("hidden");
			icon.classList.remove("fa-chevron-down");
			icon.classList.add("fa-chevron-up");
			parent.classList.add("bg-lightBeigy");
		} else {
			answer.classList.add("hidden");
			icon.classList.remove("fa-chevron-up");
			icon.classList.add("fa-chevron-down");
			parent.classList.remove("bg-lightBeigy");
		}
	}

	// Add shadow to header on scroll
	document.addEventListener("scroll", function () {
		const header = document.getElementById("main-header");
		if (header) {
			header.classList.toggle("bg-white", window.scrollY > 0);
			header.classList.toggle("shadow", window.scrollY > 0);
		}
	});

	let searchBtn = document.getElementById("search-btn"),
		searchBox = document.getElementById("search-box"),
		btnCloseSearchBox = document.getElementById("btn-close-search-box");

	if (searchBtn && searchBox) {
		searchBtn.addEventListener("click", () => {
			searchBox.classList.toggle("hidden");
			searchBtn.classList.toggle("active-search");
		});
	}

	if (btnCloseSearchBox && searchBox) {
		btnCloseSearchBox.addEventListener("click", () => {
			searchBox.classList.toggle("hidden");
			searchBtn.classList.toggle("active-search");
		});
	}

	if (searchBtn && searchBox) {
		window.addEventListener("click", function (e) {
			// console.log(searchBtn.contains(e.target));
			if (!searchBtn.contains(e.target) && !searchBox.contains(e.target)) {
				searchBox.classList.add("hidden");
			}
		});
	}

	let mobileSearch = document.getElementById("search");
	let Msearch = document.getElementById("Msearch");
	if (mobileSearch) {
		mobileSearch.addEventListener("click", function () {
			Msearch.classList.toggle("hidden");
		});
	}
});
